/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaRegolaPunteggioDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioCreationForm } from '../model/models';
import { TipoPraticaRegolaPunteggioDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioListFilter } from '../model/models';
import { TipoPraticaRegolaPunteggioPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaRegolaPunteggioRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    tipoPraticaRegolaPunteggioCreationForm: TipoPraticaRegolaPunteggioCreationForm;
}

export interface DeleteTipoPraticaRegolaPunteggioRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
}

export interface GetTipoPraticaRegolaPunteggioRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
}

export interface ListTipoPraticaRegolePunteggioRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    filter: TipoPraticaRegolaPunteggioListFilter;
    pageable: Pageable;
}

export interface UpdateTipoPraticaRegolaPunteggioRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    idRegola: string;
    tipoPraticaRegolaPunteggioPatchForm: TipoPraticaRegolaPunteggioPatchForm;
}


export interface TipoPraticaRegolaPunteggioControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea una nuova regola di punteggio sotto la categoria indicata
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole
* @param requestParameters
     */
    createTipoPraticaRegolaPunteggio(requestParameters: CreateTipoPraticaRegolaPunteggioRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioDTO>;

    /**
     * Elimina una regola di punteggio (cascade su predicati/fasce)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}
* @param requestParameters
     */
    deleteTipoPraticaRegolaPunteggio(requestParameters: DeleteTipoPraticaRegolaPunteggioRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di una regola di punteggio
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}
* @param requestParameters
     */
    getTipoPraticaRegolaPunteggio(requestParameters: GetTipoPraticaRegolaPunteggioRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioDTO>;

    /**
     * Lista paginata delle regole di punteggio della categoria (filtri: ambito, modalita_mappa, aggregatore)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole
* @param requestParameters
     */
    listTipoPraticaRegolePunteggio(requestParameters: ListTipoPraticaRegolePunteggioRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaRegolaPunteggioDTO>;

    /**
     * Replace di una regola di punteggio (richiede version)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}/regole/{idRegola}
* @param requestParameters
     */
    updateTipoPraticaRegolaPunteggio(requestParameters: UpdateTipoPraticaRegolaPunteggioRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioDTO>;

}
